export const COLLECT_AUTH_INFO_ROUTE = "/auth/login";
export const REDIRECT_PARAM = "redirect-to";
export const UNAUTHORIZED_FEEDBACK = $localize`Sorry, but you seem to be unauthorized to use this service.`;
export const UNAUTHORIZED_POSSIBLE_ACTION = $localize`Contact your account manager if you need to extend your permissions.`;
